import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/magic.ai/frontend/magicsquare/libs/shared/src/common/components/ErrorPage/ErrorPage.tsx");
